import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {StoreService} from './store.service';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  host = environment.host;
  internalHost = 'https://internal.amayakids.com/';
  version = 'api/v1';

  constructor(private _storeService: StoreService) { }

  isAuth() {
    return this.host + this.version + '/moderator/isauth';
  }

  userLogin() {
    return this.host + this.version + '/moderator/login';
  }

  userSignUp() {
    return this.host + this.version + '/moderator/create';
  }

  userPassRestore() {
    return this.host + this.version + '/user/requestpasswordreset';
  }

  logOut() {
    return this.host + this.version + '/moderator/logout';
  }

  breadcrumbs() {
    return this.host + this.version + '/moderator/breadcrumbs';
  }

  getModerators() {
    return this.host + this.version + '/moderator/index';
  }
  getModerator() {
    return this.host + this.version + '/moderator/get';
  }
  createModerator() {
    return this.host + this.version + '/moderator/create';
  }
  updateModerator() {
    return this.host + this.version + '/moderator/update';
  }
  deleteModerator() {
    return this.host + this.version + '/moderator/delete';
  }

  getConfig() {
    return this.host + this.version + '/config/get';
  }
  updateConfig() {
    return this.host + this.version + '/config/update';
  }
  getProducts() {
    return this.host + this.version + '/product/index';
  }
  getProduct() {
    return this.host + this.version + '/product/get';
  }
  createProduct() {
    return this.host + this.version + '/product/create';
  }
  updateProduct() {
    return this.host + this.version + '/product/update';
  }
  deleteProduct() {
    return this.host + this.version + '/product/delete';
  }


  getDeletedUsers() {
    return this.host + this.version + '/deletedUser/index';
  }

  getUsers() {
    return this.host + this.version + '/user/index';
  }
  getUser() {
    return this.host + this.version + '/user/get';
  }
  createUser() {
    return this.host + this.version + '/user/create';
  }
  updateUser() {
    return this.host + this.version + '/user/update';
  }
  deleteUser() {
    return this.host + this.version + '/user/delete';
  }
  exportUsersCSV() {
    return this.host + this.version + '/account/exportCsv';
  }


  getAccounts() {
    return this.host + this.version + '/account/index';
  }
  getAccount() {
    return this.host + this.version + '/account/get';
  }
  createAccount() {
    return this.host + this.version + '/account/create';
  }
  updateAccount() {
    return this.host + this.version + '/account/update';
  }
  deleteAccount() {
    return this.host + this.version + '/account/delete';
  }



  getDevices() {
    return this.host + this.version + '/device/index';
  }
  getDevice() {
    return this.host + this.version + '/device/get';
  }
  createDevice() {
    return this.host + this.version + '/device/create';
  }
  updateDevice() {
    return this.host + this.version + '/device/update';
  }
  deleteDevice() {
    return this.host + this.version + '/device/delete';
  }


  getStores() {
    return this.host + this.version + '/store/index';
  }
  getStore() {
    return this.host + this.version + '/store/get';
  }
  getSnapshot() {
    return this.host + this.version + '/store/getSnapshot';
  }
  getSnapshots() {
    return this.host + this.version + '/store/getSnapshots';
  }
  createStore() {
    return this.host + this.version + '/store/create';
  }
  updateStore() {
    return this.host + this.version + '/store/update';
  }
  duplicateStore() {
    return this.host + this.version + '/store/duplicate';
  }
  deleteStore() {
    return this.host + this.version + '/store/delete';
  }
  createSnapshot() {
    return this.host + this.version + '/store/createSnapshot';
  }

  getActions() {
    return this.host + this.version + '/action/index';
  }
  getAction() {
    return this.host + this.version + '/action/get';
  }
  createAction() {
    return this.host + this.version + '/action/create';
  }
  updateAction() {
    return this.host + this.version + '/action/update';
  }
  deleteAction() {
    return this.host + this.version + '/action/delete';
  }

  getActionStates() {
    return this.host + this.version + '/action-state/index';
  }
  getActionState() {
    return this.host + this.version + '/action-state/get';
  }
  createActionState() {
    return this.host + this.version + '/action-state/create';
  }
  updateActionState() {
    return this.host + this.version + '/action-state/update';
  }
  deleteActionState() {
    return this.host + this.version + '/action-state/delete';
  }


  getCoinFlows() {
    return this.host + this.version + '/coin-flow/index';
  }
  getCoinFlow() {
    return this.host + this.version + '/coin-flow/get';
  }
  createCoinFlow() {
    return this.host + this.version + '/coin-flow/create';
  }
  updateCoinFlow() {
    return this.host + this.version + '/coin-flow/update';
  }
  deleteCoinFlow() {
    return this.host + this.version + '/coin-flow/delete';
  }

  getCustomDataItems() {
    return this.host + this.version + '/custom-data/index';
  }
  getCustomData() {
    return this.host + this.version + '/custom-data/get';
  }
  createCustomData() {
    return this.host + this.version + '/custom-data/create';
  }
  updateCustomData() {
    return this.host + this.version + '/custom-data/update';
  }
  deleteCustomData() {
    return this.host + this.version + '/custom-data/delete';
  }

  getCustomDataFiles() {
    return this.host + this.version + '/file/index';
  }
  uploadCustomDataFile() {
    return this.host + this.version + '/file/uploadFile';
  }

  getProjects() {
    return this.host + this.version + '/project/index';
  }
  getProject() {
    return this.host + this.version + '/project/get';
  }
  createProject() {
    return this.host + this.version + '/project/create';
  }
  updateProject() {
    return this.host + this.version + '/project/update';
  }
  deleteProject() {
    return this.host + this.version + '/project/delete';
  }



  getPurchases() {
    return this.host + this.version + '/purchase/index';
  }
  getPurchase() {
    return this.host + this.version + '/purchase/get';
  }
  createPurchase() {
    return this.host + this.version + '/purchase/create';
  }
  updatePurchase() {
    return this.host + this.version + '/purchase/update';
  }
  deletePurchase() {
    return this.host + this.version + '/purchase/delete';
  }

  getReceiptByPurchase() {
    return this.host + this.version + '/purchase/getReceiptByPurchase';
  }

  getReceipt() {
    return this.host + this.version + '/receipt/get';
  }

  getReceipts() {
    return this.host + this.version + '/receipt/index';
  }

  getStoreCollections() {
    return this.host + this.version + '/store-collection/index';
  }
  getStoreCollection() {
    return this.host + this.version + '/store-collection/get';
  }
  createStoreCollection() {
    return this.host + this.version + '/store-collection/create';
  }
  updateStoreCollection() {
    return this.host + this.version + '/store-collection/update';
  }
  deleteStoreCollection() {
    return this.host + this.version + '/store-collection/delete';
  }



  getStoreVersions() {
    return this.host + this.version + '/store-version/index';
  }
  getStoreVersion() {
    return this.host + this.version + '/store-version/get';
  }
  createStoreVersion() {
    return this.host + this.version + '/store-version/create';
  }
  updateStoreVersion() {
    return this.host + this.version + '/store-version/update';
  }
  deleteStoreVersion() {
    return this.host + this.version + '/store-version/delete';
  }

  getStoreKeys() {
    return this.host + this.version + '/store-key/index';
  }
  getStoreKey() {
    return this.host + this.version + '/store-key/get';
  }
  createStoreKey() {
    return this.host + this.version + '/store-key/create';
  }
  updateStoreKey() {
    return this.host + this.version + '/store-key/update';
  }
  deleteStoreKey() {
    return this.host + this.version + '/store-key/delete';
  }



  getStoreGroups() {
    return this.host + this.version + '/store-group/index';
  }
  getStoreGroup() {
    return this.host + this.version + '/store-group/get';
  }
  createStoreGroup() {
    return this.host + this.version + '/store-group/create';
  }
  updateStoreGroup() {
    return this.host + this.version + '/store-group/update';
  }
  deleteStoreGroup() {
    return this.host + this.version + '/store-group/delete';
  }

  uploadProjectAsset() {
    console.log(this.internalHost);
    return (this._storeService.internal ? this.internalHost : '') + this.version + '/project/upload';
  }


  uploadAddressable() {
    return (this._storeService.internal ? this.internalHost : '') + this.version + '/store-version/upload';
  }

}
